import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute() {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <div className="loading">Checking authentication…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login and preserve the intended destination
    return <Navigate to="/login?mode=signin" state={{ from: location }} replace />;
  }

  // Intercept if user profile exists but terms are not accepted, redirecting to consent
  if (user && !user.accepted_terms && location.pathname !== "/consent") {
    return <Navigate to="/consent" replace />;
  }

  return <Outlet />;
}
